let parentGrade = document.querySelector(".parent-grade");
let readMoreContainer = document.querySelector(".read-more-container");
let customMediaFaq = document.querySelector(".custom-media-faq");
let customComponentDrawer = document.querySelector(".custom-component-drawer");
let drawerOverlays = document.querySelector(".drawer-overlays");
let customFooterBlocks = document.querySelector(".custom-media-floatingbtn");
let mediaQueryFaq = window.matchMedia("(max-width: 768px)");

if (readMoreContainer && parentGrade && drawerOverlays && customFooterBlocks) {
  readMoreContainer.addEventListener("click", () => {
    parentGrade.style.transform = "translateX(0)";
    drawerOverlays.classList.add("overlay-faq");
    document.body.style.overflow = "hidden";
    customFooterBlocks.style.visibility = "hidden";
  });
}

if (customComponentDrawer && parentGrade && drawerOverlays && customFooterBlocks) {
  // Triggering the cross icon
  customComponentDrawer.addEventListener("click", () => {
    parentGrade.style.transform = "translate(100%)";
    drawerOverlays.classList.remove("overlay-faq");
    document.body.style.overflow = "auto";
    customFooterBlocks.style.visibility = "visible";
  });

  // Media query handling
  customComponentDrawer.addEventListener("click", () => {
    if (mediaQueryFaq.matches) {
      parentGrade.style.transform = "translateY(100%)";
    }
  });
}

if (drawerOverlays && parentGrade && customFooterBlocks) {
  // Triggering the overlay background
  drawerOverlays.addEventListener("click", () => {
    parentGrade.style.transform = "translate(100%)";
    drawerOverlays.classList.remove("overlay-faq");
    customFooterBlocks.style.visibility = "visible";
    document.body.style.overflow = "auto";

    if (mediaQueryFaq.matches) {
      parentGrade.style.transform = "translateY(100%)";
    }
  });
}
